import React from 'react';

import style from './style.module.scss';

const Spacer = ({ size = "s24" }) => {
    return (
        <div className={`${style.spacer}${style[size] ? ` ${style[size]}` : ``}`}></div>
    )
}
export default Spacer;